import React, { useRef, useState } from "react";
import {
  Box,
  Paper,
  Button,
  Stack,
  Typography,
  Divider,
  Chip,
  Avatar,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import DatasetRoundedIcon from "@mui/icons-material/DatasetRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

import { SpecTab } from "./MainTabs/Spec/Spec";
import { PartLibTableCheckBoxes } from "./MainTabs/PartLib/PartLibTableCheckBoxes";
import { EstimationTab } from "./MainTabs/EstimationTab/EstimationTab";
import NavTabs from "../../../../components/Tabs/NavTabs";
import { usePiping, PipingProvider } from "./PipingContext";
import { SpecHeader } from "./MainTabs/Spec/SpecHeader";
import { useParams } from "react-router-dom";
import CompareRevisionsButton from "./CompareRevisionsButton";
import LoadProjectDataComboBox from "./LoadProjectDataComboBox";

const mainTabs = [
  { label: "Spec", panel: <SpecTab /> },
  { label: "Spec Library", panel: <PartLibTableCheckBoxes revision={0} /> },
  { label: "Estimation", panel: <EstimationTab /> },
];

function ProjectSelectionHeader({
  plantId,
  clientName,
  type,
  selectedProject,
  onProjectSelect,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        mb: 1.5,
        px: 1.5,
        py: 1,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        bgcolor: "background.paper",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={1.5}
        alignItems={{ xs: "stretch", md: "center" }}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ minWidth: 210 }}
        >
          <FolderOpenRoundedIcon
            fontSize="small"
          />

          <Typography
            variant="body2"
            fontWeight={700}
            sx={{  whiteSpace: "nowrap" }}
          >
            Load Project Data
          </Typography>
        </Stack>

        <Box sx={{ width: "100%", maxWidth: 360 }}>
          <LoadProjectDataComboBox
            plantId={plantId}
            clientName={clientName}
            type={type}
            label="Select Project"
            onSelect={onProjectSelect}
          />
        </Box>

        {selectedProject && (
          <Chip
            size="small"
            color="success"
            variant="outlined"
            label={selectedProject?.name || selectedProject?.link || "Selected"}
            sx={{
              maxWidth: 220,
              fontWeight: 600,
              "& .MuiChip-label": {
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
            }}
          />
        )}
      </Stack>
    </Paper>
  );
}

export default function PnIForm() {
  const {
    savePipingData,
    modelingData,
    setModelingData,
    selectedModelingRevision,
  } = usePiping();

  const [currentTab, setCurrentTab] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);

  const { plantId } = useParams();

  const clientName = "DEMO";
  const type = "pip";

  const CompareBtnRef = useRef(null);

  function handleSave() {
    savePipingData();
  }

  const handleChange = (newValue) => {
    console.log("Tab changed to:", newValue);
    setCurrentTab(newValue);
  };

  const handleProjectSelect = (project) => {
    console.log("selected project", project);
    setSelectedProject(project);
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        p: 0,
      }}
    >
      <ProjectSelectionHeader
        plantId={plantId}
        clientName={clientName}
        type={type}
        selectedProject={selectedProject}
        onProjectSelect={handleProjectSelect}
      />

      <Paper
        elevation={0}
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <NavTabs
          tabs={mainTabs}
          navLabel="data-tab"
          handleOutputChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {currentTab === 0 && (
            <Box sx={{ flexGrow: 1 }}>
              <SpecHeader />
            </Box>
          )}

          <Box display="flex" sx={{
       p: 1,
      }}>
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </Box>

          <Box display="flex" >
            <CompareRevisionsButton
              ref={CompareBtnRef}
              modelingData={modelingData}
              setModelingData={setModelingData}
              revKey={selectedModelingRevision}
            />
          </Box>
        </NavTabs>
      </Paper>
    </Box>
  );
}

export function Piping() {
  return (
    <PipingProvider>
      <PnIForm />
    </PipingProvider>
  );
}